import { useQuery } from "@apollo/client/react";
import type { SortDirection } from "../../../models/SortDirection";
import type { SkynetUserModel } from "../../../models/RolesAndPermissionsModels";
import GET_USERS from "../../queries/rolesAndPermissions/getUsers";

export const useUsers = (
  searchTerm?: string,
  groupIds?: Array<string>,
  hasPermissionOverrides?: Boolean,
  sortBy?:
    | "CREATED_AT"
    | "EMAIL"
    | "FIRST_NAME"
    | "LAST_LOGIN_AT"
    | "LAST_NAME",
  sortDirection?: SortDirection,
  skip?: number,
  take?: number,
) => {
  const { data, error, loading, refetch } = useQuery<{
    skynetUsers: {
      totalCount: number;
      items: Array<SkynetUserModel>;
    };
  }>(GET_USERS, {
    variables: {
      searchTerm,
      groupIds,
      hasPermissionOverrides,
      sortBy,
      sortDirection,
      skip,
      take,
    },
    fetchPolicy: "cache-and-network",
  });
  return { skynetUsers: data?.skynetUsers, error, loading, refetch };
};
